export default __webpack_public_path__ + "static/media/login-img.7936f822.svg";